const endpoints = {
  PROJECTS: () => 'projects?sort%5B0%5D%5Bfield%5D=idx&sort%5B0%5D%5Bdirection%5D=asc',
  TAGS: () => 'tags?sort%5B0%5D%5Bfield%5D=idx&sort%5B0%5D%5Bdirection%5D=asc',
  CONTENT: id => `contents/${id}`,
  CONTENTPIC: id => `contentPics/${id}`,
  JOURNALS: () => 'journals?sort%5B0%5D%5Bfield%5D=createdAt&sort%5B0%5D%5Bdirection%5D=desc',
};

export default endpoints;


// WEBPACK FOOTER //
// ./src/utils/endPoints.js